// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function make(label, labelStyle, title, style, classListOpt, order) {
  let classList = classListOpt !== undefined ? classListOpt : [];
  return {
    label: label,
    labelStyle: labelStyle,
    title: title,
    style: style,
    classList: classList,
    order: order
  };
}

let empty = make(undefined, undefined, undefined, undefined, undefined, undefined);

function merge(a, b) {
  return {
    label: Stdlib_Option.orElse(a.label, b.label),
    labelStyle: Stdlib_Option.orElse(a.labelStyle, b.labelStyle),
    title: Stdlib_Option.orElse(a.title, b.title),
    style: Stdlib_Option.orElse(a.style, b.style),
    classList: a.classList.concat(b.classList),
    order: Stdlib_Option.orElse(a.order, b.order)
  };
}

function mergeOpt(mbA, mbB) {
  return LumiOption.unionWith(merge, mbA, mbB);
}

function className(param) {
  return LumiReact.classList(param.classList);
}

export {
  make,
  empty,
  merge,
  mergeOpt,
  className,
}
/* empty Not a pure module */
